import { API, Storage } from "aws-amplify";
import { OffLineAPI } from "../../offline-auth/api";

let _API = JSON.parse(import.meta.env.VITE_isOffline) ? OffLineAPI : API;

// Export Constants
export const SET_PROFILE = "SET_PROFILE";
export const SET_PROFILE_IMG = "SET_PROFILE_IMG";

// Export Actions
export function getProfile() {
  return (dispatch) => {
    return _API
      .get("user", "/user?userId")
      .then((res) => {
        console.log("res === ", res);
        return dispatch(setProfile(res.data));
      })
      .catch((err) => {
        console.log("err in getProfile ", err);
        return dispatch(setProfile({}));
      });
  };
}

// Export Actions
export function saveProfile(body) {
  console.log("body ==== ", body);
  return _API
    .put("user", "/user", { body })
    .then((res) => {
      console.log("res === ", res);
      return res;
    })
    .catch((err) => {
      console.log("err in getProfile ", err);
      return err;
    });
}

// Export Actions
export function setProfile(data) {
  return {
    type: SET_PROFILE,
    data,
  };
}

export function updateProfilePic(file, fileName) {
  try {
    if (!(file instanceof File)) {
      throw new Error('Invalid file object');
    }

    let filename = Date.now() + "-" + fileName;

    // Configure storage with the correct bucket
    Storage.configure({ bucket: JSON.parse(import.meta.env.VITE_s3).PROFILEBUCKET });

    // Read file as ArrayBuffer
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = async () => {
        try {
          const arrayBuffer = reader.result;
          
          // First update the profile image URL in the database
          const body = {
            key: filename,
            // Temporary URL until S3 upload completes
            url: URL.createObjectURL(file)
          };

          const apiResponse = await _API.put("user", "/user/updateprofileimage", { body });

          if (!apiResponse.status) {
            throw new Error('Failed to update profile image in database');
          }

          // Then upload to S3
          const result = await Storage.put(filename, arrayBuffer, {
            contentType: file.type,
            ACL: "public-read"
          });

          // Get the S3 URL
          const url = await Storage.get(result.key);

          // Update profile with the final S3 URL
          const finalBody = {
            key: result.key,
            url: url
          };

          await _API.put("user", "/user/updateprofileimage", { body: finalBody });

          resolve({
            status: true,
            data: {
              profileImage: {
                key: result.key,
                url: url
              }
            }
          });
        } catch (error) {
          reject(error);
        }
      };
      reader.onerror = () => reject(new Error('Failed to read file'));
      reader.readAsArrayBuffer(file);
    });
  } catch (error) {
    console.error("Error in updateProfilePic:", error);
    throw error;
  }
}

export function setProfileImg(data) {
  return {
    type: SET_PROFILE_IMG,
    data,
  };
}